import render from './render'

export default {
  name: 'CloneButton',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  render
}
